/** Canonical Sensemaker data-table tokens — Figma `5106:9975` (Recent Campaigns). */

export const SENSEMAKER_TABLE = {
  cardBorder: '#e5e7eb',
  cardRadius: '10px',
  bodyBg: '#ffffff',
  headerBg: '#e1e7f3',
  headerText: '#4a5565',
  rowBorder: '#e5e7eb',
  primaryTextColor: '#0f172a',
  secondaryTextColor: '#4a5565',
  sortActiveColor: '#008cd0',
  sortInactiveColor: '#4a5565',
  rowMinHeight: 61,
  headerMinHeight: 48.5,
  /** MUI spacing units — 3 × 8px = 24px horizontal cell padding */
  cellPx: 3,
  cellPaddingPx: 24,
  headerRowPyPx: 16,
} as const

export const sensemakerTableSx = {
  bgcolor: SENSEMAKER_TABLE.bodyBg,
  tableLayout: 'fixed',
  width: '100%',
} as const

export const sensemakerTableHeaderCellSx = {
  bgcolor: SENSEMAKER_TABLE.headerBg,
  borderBottom: `1px solid ${SENSEMAKER_TABLE.rowBorder}`,
  color: SENSEMAKER_TABLE.headerText,
  fontSize: '12px',
  fontWeight: 600,
  letterSpacing: '0.6px',
  textTransform: 'uppercase',
  py: `${SENSEMAKER_TABLE.headerRowPyPx}px`,
  px: SENSEMAKER_TABLE.cellPx,
  lineHeight: '16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: 0,
} as const

export const sensemakerTableBodyCellSx = {
  bgcolor: SENSEMAKER_TABLE.bodyBg,
  borderBottom: `1px solid ${SENSEMAKER_TABLE.rowBorder}`,
  py: 0,
  px: SENSEMAKER_TABLE.cellPx,
  height: SENSEMAKER_TABLE.rowMinHeight,
  verticalAlign: 'middle',
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '-0.1504px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 0,
} as const

/** Actions, badges, or controls — opt out of ellipsis clipping. */
export const sensemakerTableBodyCellInteractiveSx = {
  ...sensemakerTableBodyCellSx,
  overflow: 'visible',
  maxWidth: 'none',
  whiteSpace: 'normal',
} as const

export const sensemakerTableCardSx = {
  bgcolor: SENSEMAKER_TABLE.bodyBg,
  border: `1px solid ${SENSEMAKER_TABLE.cardBorder}`,
  borderRadius: SENSEMAKER_TABLE.cardRadius,
  overflow: 'hidden',
} as const

export function sensemakerTableActionsHeaderCellSx(options?: {
  width?: string
  minWidth?: number
  textAlign?: 'left' | 'right'
}) {
  return {
    ...sensemakerTableHeaderCellSx,
    width: options?.width,
    minWidth: options?.minWidth,
    textAlign: options?.textAlign ?? 'left',
    overflow: 'visible',
    maxWidth: 'none',
  } as const
}

export function sensemakerTableActionsBodyCellSx(options?: {
  width?: string
  minWidth?: number
  textAlign?: 'left' | 'right'
}) {
  return {
    ...sensemakerTableBodyCellInteractiveSx,
    width: options?.width,
    minWidth: options?.minWidth,
    textAlign: options?.textAlign ?? 'left',
  } as const
}
